import {IconButton, type IconButtonProps} from '@primer/react'
import {clsx} from 'clsx'
import {forwardRef} from 'react'

import styles from './IconButtonSelector.module.css'

type IconButtonSelectorProps = IconButtonProps & {
  selected: boolean
  selectedIcon?: IconButtonProps['icon']
  'aria-labeledby'?: string
}

export const IconButtonSelector = forwardRef<HTMLButtonElement, IconButtonSelectorProps>((props, ref) => {
  const {selected, icon: Icon, selectedIcon: SelectedIcon, ...rest} = props
  const IconComponent = selected && SelectedIcon ? SelectedIcon : Icon

  return (
    <IconButton {...rest} className={clsx(styles.anchor)} icon={IconComponent} data-selected={selected} ref={ref} />
  )
})

IconButtonSelector.displayName = 'IconButtonSelector'
